<template>
  <div class="butons">
    <div
      class="colButon"
      style="background-image: url('/images/bilet-satin-al.jpg')"
    >
      <router-link to="/nerede">
        <div class="ortala">
          <h2>BİLET SATIN AL</h2>
          <img src="images/icn-right.svg" alt="" />
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "biletmiEtkinlikmi",
  mounted() {
    this.$root.tabName = 'gelenler'
  }
};
</script>

